<template>
  <b-message :type="notificationType" class="multiline">
    <slot />
  </b-message>
</template>

<script setup lang="ts">
import { BMessage } from 'buefy'

withDefaults(defineProps<{ notificationType?: string }>(), {
  notificationType: 'is-info',
})
</script>
<style scoped>
.multiline {
  white-space: pre-line;
}
</style>
